"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.arbitraryUserAnalytics = arbitraryUserAnalytics;
const fast_check_1 = require("fast-check");
function arbitraryUserAnalytics() {
    const identifyErrorCount = (0, fast_check_1.integer)({ min: 1 });
    const created_at = (0, fast_check_1.integer)();
    const updated_at = (0, fast_check_1.integer)();
    return (0, fast_check_1.record)({
        identifyErrorCount,
        created_at,
        updated_at,
    });
}
//# sourceMappingURL=userAnalytics.js.map